import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SeminarService {

  public baseUrl=environment.apiUrl;
  constructor(private http: HttpClient) {}

  public getSeminarSessions(){
    var res=this.http.get(this.baseUrl+"api/seminar-sessions/avl-sessions",{observe:'response'});
    return res;
  }

  public registerForSeminar(seminarData) {
    var res = this.http.post(this.baseUrl + "api/seminar-registrations/register", seminarData, { observe: 'response' });
    return res;
  }
}
